import { render } from "./Captcha.vue?vue&type=template&id=72994972"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"

import "./Captcha.vue?vue&type=style&index=0&id=72994972&lang=css"
script.render = render

export default script